import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Moon, BookOpen, Sparkles, Wind, User, Eye } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";
import { useLang } from "../contexts/LanguageContext";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = useAuth();
  const { theme } = useTheme();
  const { t } = useLang();
  const isDark = theme === "dark";

  const tabs = [
    { path: "/", icon: Moon, label: t("navHome"), testId: "nav-accueil" },
    { path: "/interpret", icon: Sparkles, label: t("navDreams"), testId: "nav-reves" },
    { path: "/signs", icon: Eye, label: t("navSigns"), testId: "nav-signes" },
    { path: "/wellness", icon: Wind, label: t("navWellness"), testId: "nav-wellness" },
    ...(isLoggedIn
      ? [{ path: "/profile", icon: User, label: t("navProfile"), testId: "nav-profil" }]
      : [{ path: "/journal", icon: BookOpen, label: t("navJournal"), testId: "nav-journal" }]),
  ];

  return (
    <nav
      data-testid="bottom-navigation"
      className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-xl border-t"
      style={{
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        background: isDark ? "rgba(15, 23, 42, 0.85)" : "rgba(255, 255, 255, 0.85)",
        borderColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.08)",
      }}
    >
      <div className="max-w-md mx-auto flex justify-around items-center px-2 pt-2 pb-2">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const Icon = tab.icon;
          return (
            <button
              key={tab.path}
              data-testid={tab.testId}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center gap-0.5 py-1.5 px-3 rounded-xl transition-all duration-200 min-w-[50px] ${
                isActive
                  ? isDark ? "text-amber-400 bg-amber-400/10" : "text-amber-600 bg-amber-500/15"
                  : isDark ? "text-slate-400 hover:text-slate-200" : "text-slate-500 hover:text-slate-700"
              }`}
            >
              <Icon size={20} strokeWidth={isActive ? 2.5 : 1.5} />
              <span className="text-[9px] font-medium tracking-wide">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
